// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3hcDu","calendarButtons":"ClockData_calendarButtons__cjZTv"};